import React from 'react';
import {
    Home, Info, AccountCircle, CreditCard, Lock, CalendarMonth, Add, AutoAwesome, BatchPrediction, BlurOn, BurstMode, CheckCircle, Cancel, Layers, DoneAll, Bolt,
    AccountBalanceWallet, Wallet, ShoppingCart, Receipt
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';

const iconMap = {
    home: Home,
    info: Info,
    account: AccountCircle,
    credit_card: CreditCard,
    lockIcon: Lock,
    calender: CalendarMonth,
    add: Add,
    awesome: AutoAwesome,
    prediction: BatchPrediction,
    blur_on: BlurOn,
    burst_mode: BurstMode,
    check_circle: CheckCircle,
    cancel: Cancel,
    layers: Layers,
    all_done: DoneAll,
    bolt: Bolt,
    wallet_balance: AccountBalanceWallet,
    wallet: Wallet,
    cart: ShoppingCart,
    receipt: Receipt
    // Add more icons as needed
};

export const CustomIcon = ({ iconName = 'home', message = '', sx = {} }) => {
    const IconComponent = iconMap[iconName];

    if (!IconComponent) {
        return <p variant="body1"> {iconName}</p>
    }

    if (message) {
        return <Tooltip title={message} arrow >
            <IconComponent sx={sx} />
        </Tooltip>
    }

    return <IconComponent sx={sx} />;
}